export class References {
  constructor(
    public vocabCategories: any[],
    public vocabEntries: any[],
    public functionalGrammarCategories: any[],
    public functionalGrammarEntries: any[],
    public systemicGrammarCategories: any[],
    public systemicGrammarEntries: any[],
    public textPatterns: any[],
    public textTypes: any[],
    public detailedCanDoStatementCategories: any[],
    public detailedCanDoStatementEntries: any[],
    public globalCanDoStatementCategories: any[],
    public globalCanDoStatementEntries: any[],
    public verbalActionCategories?: any[],
    public verbalActionEntries?: any[]
  ) {
  }
}
